import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProducts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/product/list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProduct(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/product/?id=${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addProduct(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/product", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addProductFromHktv(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/product/hktv", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProduct(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/product", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchHKTVCategoryData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/hktv-list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
